var _path, _rect, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32_\u533B\u6280\u7AD9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.92,4h-40a4,4,0,0,0-4,4V56a4,4,0,0,0,4,4h40a4,4,0,0,0,4-4V8A4,4,0,0,0,51.92,4Zm0,52h-40V8h40Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.92,
    y: 40.02,
    width: 40,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.92,
    y: 48.03,
    width: 8,
    height: 4,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 48.03,
    width: 8,
    height: 4,
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.89,
    y: 48.03,
    width: 8,
    height: 4,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9,21.15h-12a2,2,0,0,0-1.84,1.16l-1.59,3.55-5-8.67a2.09,2.09,0,0,0-3.18-.42l-5.74,5.73a1.94,1.94,0,0,0,0,2.75l.08.08a1.94,1.94,0,0,0,2.75,0l3.91-3.91L29,31.26a2,2,0,0,0,2.66.71l.1,0,0,0,.11-.08.21-.15h0a1.83,1.83,0,0,0,.45-.63l2.65-5.88H45.9a2,2,0,0,0,2-1.95v-.11A2,2,0,0,0,45.9,21.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalStation);
export default __webpack_public_path__ + "static/media/medicalStation.a4b6000f.svg";
export { ForwardRef as ReactComponent };